<template>
<div class='totals-indicator'>
  <div class='totals-indicator__title'> {{ this.$t(title) }}</div>
  <div class='totals-indicator__data'>{{data}}</div>
</div>
</template>

<script>
export default {
  name: 'TotalsIndicator',
  props: {
    data: {
      type: Number,
      required: true,
      default: () => 0,
    },
    title: {
      type: String,
      required: true,
      default: () => '',
    },
  },
};
</script>

<style lang='scss' scoped>
@import '~@/assets/styles/design-system';

.totals-indicator{
  display: flex;
  flex-direction: column;
  padding-right: $space-5;
  &__title{
    color: var(--text-primary);
    display: flex;
    font-family: $font-family-semibold;
    font-size: $font-size-md;
    letter-spacing: 0;
    line-height: rem(17);
  }
  &__data{
    color: var(--text-primary);
    font-family: $font-family-regular;
    font-size: $font-size-base;
    letter-spacing: 0;
    line-height: $space-4;
  }
}
</style>
